import React, { useEffect, useState } from 'react';
import { formatPrice, getWeb3 } from '../helper/functions';
import { DEFAULT_CHAIN, SYMBOL, contract } from '../helper/constant';
import stakeAbi from '../json/bscstake.json';
import { useAccount, useNetwork } from 'wagmi';
import { useEthersSigner } from '../hooks/useEthersProvider';
import { getContract } from '../helper/contractHelper';
import { toast } from 'react-toastify';
import { useWeb3Modal } from '@web3modal/react';
import { ethers } from 'ethers';
import { useLocation } from 'react-router-dom';
import MyWallet from './MyWallet';
import TabButton from './TabButton';
import 'react-rangeslider/lib/index.css';
import { TextField, InputAdornment, Button } from '@mui/material';
import bnbImg from '../img/binance-coin.png';
import CustomButton from './CustomButton';




export default function Stake({ accStats, setUpdater, setTab, tab , rewardStats }) {
    const { address, isConnected } = useAccount()
    const { chain } = useNetwork();
    const signer = useEthersSigner()
    const { open } = useWeb3Modal()
    const [amount, setAmount] = useState(0);
    let web3 = getWeb3(DEFAULT_CHAIN);
    const [loading, setLoading] = useState({
        stake: false,
        compound: false,
        withdraw: false,
    });
    const [refAddress, setRefAddress] = useState('');
    const search = useLocation().search;
    


    useEffect(() => {
        let refAddr = '';
        const queryChainId = new URLSearchParams(search).get('ref');
        if (queryChainId !== '') {
            refAddr = queryChainId;
        }
        setRefAddress(refAddr);
        // eslint-disable-next-line
    }, [])

    const handleChangeAmount = (e) => {

        let value = e.target.value;
        const patt = /^\d+\.{0,1}\d{0,6}$/;
        if (value === '' || value === 0) {
            setAmount(value)
        }
        else if (patt.test(value)) {
            setAmount(value)
        }
        return;
    }

    const handleSubmit = async (loader = 'stake') => {
        setLoading((prevState) => ({
            ...prevState,
            [loader]: true,
        }));
        try {

            if (address && isConnected) {
                if (chain.id === DEFAULT_CHAIN) {

                    if (parseFloat(accStats.bnbbal) >= parseFloat(amount)) {

                        let tokenStakingAddress = contract[DEFAULT_CHAIN].STAKE_ADDRESS;
                        let stakeContract = getContract(stakeAbi, tokenStakingAddress, signer);
                        let refAddr = refAddress ? refAddress : '0x0000000000000000000000000000000000000000';
                        var tx;
                        if (loader === 'stake') {
                            tx = await stakeContract.deposit(refAddr, { 'from': address, value: ethers.utils.parseEther(amount.toString()) });
                        }
                        else if (loader === 'compound') {
                            tx = await stakeContract.compound({ 'from': address });
                        }
                        else if (loader === 'withdraw') {
                            tx = await stakeContract.withdraw({ 'from': address });
                        }
                        else {
                            toast.error('something went wrong!');
                            setLoading((prevState) => ({
                                ...prevState,
                                [loader]: false,
                            }));
                            return false;
                        }


                        toast.loading('Waiting for confirmation 👌')

                        var interval = setInterval(async function () {
                            var response = await web3.eth.getTransactionReceipt(tx.hash);
                            if (response != null) {
                                clearInterval(interval)
                                if (response.status === true) {
                                    toast.dismiss()
                                    toast.success('success ! your last transaction is success 👍');
                                    setUpdater(Math.random());
                                    setLoading((prevState) => ({
                                        ...prevState,
                                        [loader]: false,
                                    }));
                                }
                                else if (response.status === false) {
                                    toast.dismiss()
                                    toast.error('error ! Your last transaction is failed.');
                                    setUpdater(Math.random());
                                    setLoading((prevState) => ({
                                        ...prevState,
                                        [loader]: false,
                                    }));
                                }
                                else {
                                    toast.dismiss()
                                    toast.error('error ! something went wrong.');
                                    setUpdater(Math.random());
                                    setLoading((prevState) => ({
                                        ...prevState,
                                        [loader]: false,
                                    }));
                                }
                            }
                        }, 5000);

                    }
                    else {
                        toast.dismiss()
                        toast.error('you don\'t have enough balance !');
                        setLoading((prevState) => ({
                            ...prevState,
                            [loader]: false,
                        }));
                    }

                }
                else {
                    toast.error('Please select Binance Mainnet Network !');
                    setLoading((prevState) => ({
                        ...prevState,
                        [loader]: false,
                    }));
                }
            }
            else {
                toast.dismiss()
                toast.error('Please Connect Wallet!');
                setLoading((prevState) => ({
                    ...prevState,
                    [loader]: false,
                }));
            }

        }
        catch (err) {
            toast.dismiss()
            toast.error(err.reason);
            setLoading((prevState) => ({
                ...prevState,
                [loader]: false,
            }));
        }
    }

    const handleMaxClick = () => {
        if (address) {
            setAmount(parseFloat(parseFloat(accStats.bnbbal).toFixed(8)))
        }
        else {
            setAmount(0);
        }
    };

    return (

        <div className='d-flex justify-content-center mb-4 row' style={{ marginLeft: 0 }}>
            <div className='col-12 col-xl-7 card'>

                <div className='d-flex justify-content-center row'>
                    <TabButton setTab={setTab} tab={tab} />
                    <div className='col-12 col-xl-7'>
                        <div className='row'>
                            <div className='col-12'>
                                <h4 className='text-center'>Stake & Earn</h4>
                                <h5 className='text-center'>Compound 2% Daily</h5>
                                <p className='text-center mt-2 text-white'>BNB Balance : {formatPrice(accStats.bnbbal)}</p>
                                <TextField
                                    autoComplete="off"
                                    variant="outlined"
                                    placeholder='BNB Amount'
                                    fullWidth
                                    value={amount}
                                    onChange={(e) => handleChangeAmount(e)}
                                    InputLabelProps={{
                                        style: { color: '#bbb' }, // Lighter color for label text
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <img src={bnbImg} alt='bnb' height="30px" />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Button
                                                    variant="text"
                                                    onClick={handleMaxClick}
                                                    sx={{
                                                        boxSizing: 'border-box',
                                                        margin: 0,
                                                        border: 'none',
                                                        outline: 'none',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        position: 'relative',
                                                        background: '#17b78566',
                                                        fontFamily: 'inherit',
                                                        fontWeight: 700,
                                                        width: 'auto',
                                                        lineHeight: '1em',
                                                        fontSize: '10px',
                                                        borderRadius: '6px',
                                                        padding: '11px 16px',
                                                        minWidth: '50px',
                                                        color: '#fff',
                                                    }}
                                                >
                                                    Max
                                                </Button>
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            borderRadius: '8px', // Rounded borders
                                            backgroundColor: '#0c0e13', // Dark background
                                            border: '0.5px solid #555', // Darker border
                                            color: '#fff', // White text color
                                        },
                                    }}
                                    sx={{
                                        margin: '10px 0',
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#555', // Border color for default state
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#bbb', // Border color on focus
                                            },
                                        },
                                    }}
                                />
                                {
                                    address && isConnected ? (
                                        parseFloat(accStats.bnbbal) >= parseFloat(amount) ? (
                                            <CustomButton label='Stake' loading={loading.stake} onClick={() => handleSubmit('stake')} />
                                        ) : (
                                            <CustomButton label='Stake' disabled={true} onClick={() => open()} />
                                        )) : (
                                        <CustomButton onClick={() => open()} />
                                    )
                                }
                                <div className='mt-5'>
                                    <div className='card-gray mb-2 text-center'>
                                        <div className='card-body'>
                                            <div class="ms-3">
                                                <h6 class="text-yellow mb-2">Avlible Balance</h6>
                                                <h5 class="mb-0">{rewardStats.pendingReward ? formatPrice(rewardStats.pendingReward, 8) : 0} {SYMBOL}</h5>
                                            </div>
                                            <div className='mt-2'>
                                                <CustomButton loading={loading.compound} onClick={() => handleSubmit('compound')} label='compound' width='40%' margin='5px' padding="10px 10px" />
                                                <CustomButton loading={loading.withdraw} onClick={() => handleSubmit('withdraw')} label='withdraw' width='40%' margin='5px' padding="10px 10px" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <MyWallet accStats={accStats} />
        </div>

    )
}
